/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'hide-password-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M22.854 4.146a.5.5 0 0 0-.707 0l-20 20a.5.5 0 1 0 .706.707l20-20a.5.5 0 0 0 0-.707zM5.214 19.666l4-4a3.466 3.466 0 0 1 4.45-4.452l3.318-3.317A12.344 12.344 0 0 0 12.5 7C5.596 7 0 13.621 0 14.5c0 .532 2.06 3.167 5.214 5.166zM19.796 9.325l-4.01 4.01a3.466 3.466 0 0 1-4.45 4.45l-3.313 3.313A12.261 12.261 0 0 0 12.5 22c6.904 0 12.5-6.563 12.5-7.5 0-.567-2.056-3.19-5.204-5.175z"/>'
  }
})
